templates = require 'app/scripts/views/internal/templates'
View = require 'app/scripts/views/internal/view'
t = require('app/scripts/views/internal/teacup-with-helpers')('select_member')

template = t.renderable ({ text, extraText, mentionCount }) ->
  t.li { class: 'item js-member-item' }, ->
    t.a { href: "#", class: 'js-select-member ', title: text, autocompleteText: text }, ->

      t.span '.text', title: "card", ->
        t.text "#{extraText} (#{mentionCount})"

module.exports = class SelectFilterableView extends View
  render: ->
    @$el.html(template(@options))

    @
